import { appConfig, headerConfig, refineHeader } from "../../config";

export const dealService = {
  getDealCurrent,
  getProductCurrent,
  getAuctionCurrent,
  getDealPending,
  getProductPending,
  getAuctionPending,
  getDealUpcoming,
  getProductUpcoming,
  getAuctionUpcoming,
  getDealPast,
  getProductPast,
  getAuctionPast,
  deleteDeal,
  getDealDetail,
  editDealList,
  editProductList,
  editAuctionList,
  addDealLocation,
  getDealCities,
  deleteDealLocation,
  deleteImage,
  getOrderDeatil,
  confirmClose,
  uploadExternalVoucher,
  getOrderDeals,
  saveOrderDeal,
  getExternalVoucher,
  updateAttribute,
  updateDealImgOrdering,
  uploadImage,
  getDealSchedule,
  getProductSchedule,
  getAuctionSchedule,
  updateQuantity,
  getChildDeals,
  getDealContract,
};

function saveOrderDeal(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}offer-order/save`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getOrderDeals(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}offer-order/city-category-deals`, requestOptions)
    .then(handleResponse)
    .then(dealList => {
      return dealList;
    });
}

function getDealCities() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}deal/dealCities`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getOrderDeatil(dealID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}deal/orders/${dealID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getDealCurrent(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/currentOffers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getProductCurrent(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}product/currentProducts`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getAuctionCurrent(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}auction/currentAuctions`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getDealPending(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/pendingOffers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getProductPending(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}product/pendingProducts`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getAuctionPending(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}auction/pendingAuctions`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getDealUpcoming(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/futureOffers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getProductUpcoming(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}product/futureProducts`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getAuctionUpcoming(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}auction/futureAuctions`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getDealPast(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/pastOffers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getProductPast(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}product/pastProducts`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getAuctionPast(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}auction/pastAuctions`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function addDealLocation(formData, dealID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/location`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function editDealList(fromData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: fromData
  };

  return fetch(`${appConfig.api.url}deal/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function editProductList(fromData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: fromData
  };

  return fetch(`${appConfig.api.url}product/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function editAuctionList(fromData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: fromData
  };

  return fetch(`${appConfig.api.url}auction/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getDealDetail(dealID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}deal/detail/${dealID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function deleteDeal(dealID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}deal/delete/${dealID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteImage(id) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}deal/delete-img/${id}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteDealLocation(dealID, dealLocationID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ dealID: dealID })
  };

  return fetch(
    `${appConfig.api.url}deal/delete-location/${dealLocationID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function confirmClose(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/close`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function uploadExternalVoucher(fromData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: fromData
  };

  return fetch(`${appConfig.api.url}voucher/load-external-voucher`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getExternalVoucher(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/external-vouchers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}
function updateAttribute(fromData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(fromData)
  };

  return fetch(`${appConfig.api.url}deal/edit-img`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateDealImgOrdering(fromData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(fromData)
  };

  return fetch(`${appConfig.api.url}deal/order-img`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function uploadImage(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}deal/cropped-deal-img`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getDealSchedule(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal/scheduledOffers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getProductSchedule(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}product/scheduledProducts`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getAuctionSchedule(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}auction/scheduledAuctions`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function updateQuantity(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}deal/add-quantity`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function getChildDeals(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}deal/child-deal`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function getDealContract(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}deal/ContractList`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}



// WEBPACK FOOTER //
// ./src/app/services/API/dealService.js